"use client";

import { ColumnDef } from "@/components/shared/data-table";
import { GameImage, FollowersChange } from "@/components/shared";
import type { PublisherGameWishlist } from "../types";
import { RANK_LIST_CONFIGS } from "@/features/rank-list/shared";
import type { SkeletonColumn } from "@/components/shared/list-skeleton/types";

const PRIMARY_COLOR = RANK_LIST_CONFIGS.wishlist.primaryColor;

export const publisherGameWishlistColumns: ColumnDef<PublisherGameWishlist>[] = [
  {
    header: "Rank",
    accessorKey: "wishlist_rank",
    cell: (item) => (
      <span className="font-bold text-[13px]" style={{ color: PRIMARY_COLOR }}>
        #{item.wishlist_rank}
      </span>
    ),
    width: "w-16",
  },
  {
    header: "Image",
    noPadding: true,
    width: "w-[100px]",
    cell: (item) => (
      <div className="w-[100px] h-[37px] flex-shrink-0">
        <GameImage
          src={item.capsule_image || item.header_image}
          alt={item.name}
          width={100}
          height={37}
        fillContainer
        />
      </div>
    ),
  },
  {
    header: "Name",
    accessorKey: "name",
    cell: (item) => (
      <span className="text-white font-medium text-[13px]">{item.name}</span>
    ),
  },
  {
    header: "Release",
    accessorKey: "release_date",
    cell: (item) => (
      <span className="text-[#8f98a0] text-[11px]">
        {item.coming_soon ? "Coming Soon" : item.release_date || "—"}
      </span>
    ),
  },
  {
    header: "1D",
    accessorKey: "wishlist_rank_1d",
    align: "right",
    cell: (item) => <FollowersChange value={item.wishlist_rank_1d} />,
  },
  {
    header: "7D",
    accessorKey: "wishlist_rank_7d",
    align: "right",
    cell: (item) => <FollowersChange value={item.wishlist_rank_7d} />,
  },
  {
    header: "30D",
    accessorKey: "wishlist_rank_30d",
    align: "right",
    cell: (item) => <FollowersChange value={item.wishlist_rank_30d} />,
  },
];

export const publisherGameWishlistSkeletonConfig: SkeletonColumn[] = [
  { label: "Rank", type: "number", width: "w-16" },
  { label: "Image", type: "image", noPadding: true },
  { label: "Name", type: "text", width: "w-48" },
  { label: "Release", type: "date", width: "w-24" },
  { label: "1D", type: "number", width: "w-16" },
  { label: "7D", type: "number", width: "w-16" },
  { label: "30D", type: "number", width: "w-16" },
];
